import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';

const IncomeSourceDetailSummaryComponent = ({ incomeItemDetails }) => {
  const { t } = useTranslation();
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={3}>
        {t('IncomeSources.Detail.OrderNo')} : <span> {incomeItemDetails.orderNo} </span>
      </Grid>
      <Grid item xs={12} sm={3}>
        {t('IncomeSources.Detail.Name')} : <span> {incomeItemDetails.name} </span>
      </Grid>
      <Grid item xs={12} sm={3}>
        {t('IncomeSources.Detail.Code')} : <span> {incomeItemDetails.code} </span>
      </Grid>
      <Grid item xs={12} sm={3}>
        {t('IncomeSources.Detail.Description')} : <span> {incomeItemDetails.description} </span>
      </Grid>
    </Grid>
  );
};

IncomeSourceDetailSummaryComponent.propTypes = {
  incomeItemDetails: PropTypes.object.isRequired
};

export default IncomeSourceDetailSummaryComponent;
